import type { RenamePlan } from '@cli-types/core-engine/snapshots.js'

export function buildRenamePlanAliasMap(plan: RenamePlan): Map<string, string> {
  return new Map(plan.customCells.map((rename) => [rename.newPath, rename.oldPath]))
}
